import { Injectable } from '@angular/core';
import {AuthHttp} from '../auth/http/auth-http.service';
import {environment} from '../../../../../environments/environment';
import {Observable} from 'rxjs/Observable';
import {User} from '../../interfaces/User';
import {UsersResponse} from '../../interfaces/UsersResponse';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class UserService {
  private usersUrl = 'users';

  constructor(private http: AuthHttp) { }
  public getUser(id): Observable<User>  {
    const url = `${environment.baseUrl}${this.usersUrl}/${id}`;
    return this.http.get(url).map((res) => res.json());
  }
  public getUsers(limit: number = 10, page = 1, search = '', orderBy = 'name', direction = 'asc'): Promise<UsersResponse> {
    const url = `${environment.baseUrl}${this.usersUrl}?limit=${limit}&page=${page}&search=${search}&orderBy=${orderBy}&direction=${direction}`;
    return this.http.get(url).map(res => res.json()).toPromise();
  }
  public update(id, data): Promise<User> {
    const url = `${environment.baseUrl}${this.usersUrl}/${id}`;
    return this.http.put(url, data).map(res => res.json()).toPromise();
  }
  public create(data): Promise<User> {
    const url = `${environment.baseUrl}${this.usersUrl}`;
    return this.http.post(url, data).map(res => res.json()).toPromise();
  }

  /**
   * Destroys a user
   * @param id
   * @returns Promise
   */
  public delete(id) {
    const url = `${environment.baseUrl}${this.usersUrl}/${id}`;
    return this.http.delete(url).map(res => res.json()).toPromise();
  }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/user/services/user/user.service.ts